import { render, staticRenderFns } from "./ProfileDetailGrid.vue?vue&type=template&id=50dd0e84&"
import script from "./ProfileDetailGrid.vue?vue&type=script&lang=js&"
export * from "./ProfileDetailGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports